












import { defineComponent, PropType } from '@nuxtjs/composition-api';
import useActiveLink from '~/hooks/useActiveLink';

type Link = {
  text: string;
  href: string;
};

export default defineComponent({
  name: 'InPageNavigation',
  props: {
    links: {
      type: Array as PropType<Link[]>,
      required: true
    }
  },
  setup(props) {
    const { activeLink } = useActiveLink(props.links);

    return {
      activeLink
    };
  }
});
